import { Collection } from "../services/collection";
import { post } from "../services/request";

export class Admin extends Collection {
  constructor() {
    super('admin')
  }
  public login = async ({ username, password }: any) => post('admin/login', { username, password });
  public logout = async () => post('admin/logout', {});
}